import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
	return (
		<>
			<Text translationNameSpace="global" translationKey="pageNotFoundLabel" size="xxl" />
			<Link to="/home">
				<Text translationNameSpace="global" translationKey="homePageLabel" asFragment={true} />
			</Link>
		</>
	);
};

export default NotFoundPage;
